import { AuthService } from '@/app/core/services/auth.service';
import { DialogComponent } from '../dialog/dialog.component';
import { Component, inject, Input, ViewChild } from '@angular/core';

export interface SidebarMenuItem {
  routerLink: string;
  titulo: string;
  iconoInactivo: string;
  iconoActivo: string;
  isForRoot: boolean;
}

/**
 * Ítem del panel "switcher" (selector de sistema) del sidebar. `locked` ya
 * viene resuelto por quien arma el array (el componente "shell" de cada
 * feature) — el sidebar no calcula permisos, solo pinta lo que le pasan.
 */
export interface SidebarSwitcherItem {
  label: string;
  icon: string;
  route: string;
  locked: boolean;
}

@Component({
  selector: 'c-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
  standalone: false,
})
export class SidebarComponent {
  @Input() menu: SidebarMenuItem[] = [];
  @Input() switcherItems: SidebarSwitcherItem[] = [];

  collapse = true;

  private readonly auth = inject(AuthService);

  @ViewChild('dialog') dialog!: DialogComponent;
  logout() {
    this.dialog.confirm(
      '¿Realmente desea cerrar su sesión?',
      'Cierre de sesión',
      () => {
        this.auth.logout().subscribe();
      },
    );
  }

  showSwitcher = false;

  panelPosition = {
    top: 0,
    left: 0,
  };

  openSwitcher(el: HTMLElement) {
    const rect = el.getBoundingClientRect();

    this.panelPosition = {
      // Centrado verticalmente respecto al botón (el template le aplica
      // translateY(-50%)), separado un poco a la derecha.
      top: rect.top + rect.height / 2,
      left: rect.right + 8,
    };

    this.showSwitcher = true;
  }

  closeSwitcher() {
    this.showSwitcher = false;
  }

  keepOpen() {
    this.showSwitcher = true;
  }
}
